/* eslint-disable import/no-cycle */
import Http from '@/api/http';
/* eslint-enable import/no-cycle */

export default class AdHocPurchase {
    static stores() {
        return Http.get('/ad_hoc_purchase/stores');
    }

    static offers(storeId) {
        return Http.get(`/ad_hoc_purchase/offers/${storeId}`);
    }

    static commit({
        ssoId,
        storeId,
        offerId,
        validFrom,
        validTo,
    }) {
        return Http.post('/ad_hoc_purchase/commit', {
            ssoId,
            storeId,
            offerId,
            validFrom,
            validTo,
        });
    }

    static terminate({
        ssoId,
        purchaseId,
    }) {
        return Http.post('/ad_hoc_purchase/terminate', {
            ssoId,
            purchaseId,
        });
    }
}
